import React from "react";
import PropTypes from "prop-types";
import { LoaderCircle, X } from "lucide-react";

import { cn } from "utils";

const CustomSearchBox = ({
  onChange,
  onClear,
  value,
  className,
  showLoadingIndicator,
  placeholder = "Search...",
  id,
}) => {
  return (
    <div id={id} className={cn("ais-SearchBox w-full", className)}>
      <div className="ais-SearchBox-form">
        <input
          type="search"
          placeholder={placeholder}
          className="ais-SearchBox-input"
          onChange={onChange}
          value={value}
        />
        {showLoadingIndicator && (
          <span className="ais-SearchBox-loadingIndicator !right-0.5">
            <LoaderCircle
              strokeWidth={1}
              size={20}
              className="animate-spin opacity-50"
            />
          </span>
        )}
        {!showLoadingIndicator && value && (
          <button
            title="Clear the search query"
            className="ais-SearchBox-reset !right-0.5 w-[18px]"
            onClick={onClear}
          >
            <X color="#484c7a" />
          </button>
        )}
      </div>
    </div>
  );
};

CustomSearchBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  value: PropTypes.string,
  className: PropTypes.string,
  showLoadingIndicator: PropTypes.bool,
  placeholder: PropTypes.string,
  id: PropTypes.string,
};

export default CustomSearchBox;
